import { ACTIONS_TYPES } from 'redux/helper';
import { service } from 'services';
import { hotGetAction } from 'utils';

export default {
  getAll: async () => hotGetAction({
    action: ACTIONS_TYPES.LOCATION.GET_ALL,
    apiResult: service.location.getAll(),
    isRetrieveItems: true,
  }),

  get: async ({ regionId }) => hotGetAction({
    action: ACTIONS_TYPES.LOCATION.GET,
    apiResult: service.location.get({ regionId }),
  }),

  getLocations: async ({ regionId, locationId }) => hotGetAction({
    action: ACTIONS_TYPES.LOCATION.GET_LOCATION,
    apiResult: service.location.getLocations({ regionId, locationId }),
  }),
};
